import carousel1 from '@assets/carousel1.jpg';
import carousel2 from '@assets/carousel2.jpg';
import carousel3 from '@assets/carousel3.jpg';

let carouselImage = [
	{
		title: 'Love is passion',
		description: 'Nothing bigger than mother`s love',
		urls: carousel1,
	},
	{
		title: 'The biggest gift',
		description: 'One of beatiful creatures',
		urls: carousel2,
	},
	{
		title: 'Unconditionally being loved',
		description: 'Precious treasure ever',
		urls: carousel3,
	},
];

export default carouselImage;
